import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import CommonProblemModal from "./components/CommonProblemModal.vue";
import { mapState } from "vuex";
export default {
  name: "commonProblem",
  components: {
    Modal: CommonProblemModal
  },
  data: function data() {
    return {
      searchForm: {
        ps: 20,
        pn: 1,
        isOpen: 1
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  computed: _objectSpread({}, mapState("d2admin/user", ["info"])),
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    showModal: function showModal(row) {
      this.$refs.modal.show(row);
    },
    toSubPage: function toSubPage(row) {
      this.$router.push({
        path: "/consult/commonProblemSub",
        query: {
          id: row.id,
          name: row.categoryZh
        }
      });
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.tableLoading = true;
              _context.n = 1;
              return _this.$api.getFaqList(_this.searchForm);
            case 1:
              res = _context.v;
              _this.tableData = res.data || [];
              _this.tableLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    delData: function delData(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.delFaqInfo({
                id: row.id
              });
            case 1:
              res = _context2.v;
              res.data && _this2.$message.success("已删除");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    update: function update(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.updateFaqInfo(row);
            case 1:
              _this3.$message.success("更新成功");
              _this3.getData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};